// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6158) return "static/chunks/6158-576582597ac791dc.js";
	if (chunkId === 8139) return "static/chunks/8139-13747c4c2994f4af.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2350":"850de1f98624db06","3179":"3ddc9f734b79f5cf","5560":"992e7c4a390b743f","7573":"b3748590a4b6c27d"}[chunkId] + ".js";
};